import text from './text.json'
import classNames from 'classnames'
import './index.scss'
import Badge from '../../../core/badge'
import Dropdown from '../../../core/dropdown'
import {EditIcon, HorizontalMoreIcon, ListIcon, TrashIcon} from '../../../../icons'
import {MenuDivider, MenuItem} from '@szhsin/react-menu'
import {colors} from '../../../../utils/colors'
import moment from 'moment'
import Tooltip from '../../../core/tooltip'
import TextHelper from '../../../../utils/text'
import {setConfirmIsActive} from '../../../../stores/alert'
import {useDispatch} from 'react-redux'

const ActionButton = ({isDarkMode, dispatch, onPopup}) => {
    return <Dropdown menuButton={<button  className={classNames({
        'table-action-btn': true,
        dark: isDarkMode
    })}><HorizontalMoreIcon/></button>}>
        <MenuItem onClick={onPopup}>
            <span className="d-flex"><EditIcon/></span>
            <span>{text.edit}</span>
        </MenuItem>
        <MenuDivider/>
        <MenuItem className="danger" onClick={() => {
            dispatch(setConfirmIsActive(true))
        }}>
            <span className="d-flex"><TrashIcon stroke={colors.colorRed}/></span>
            <span>{text.delete}</span>
        </MenuItem>
    </Dropdown>
}

const ListItem = ({item, isDarkMode, showEditModal}) => {
    const dispatch = useDispatch()
    const updatedAt = moment(item?.updated_at).format('YYYY-MM-DD HH:mm')

    const handleEditPopup = () => {
        showEditModal()
    }

    return (
        <div className={classNames('ruleset-item', {
            dark: isDarkMode
        })}>
            <div className="ruleset-item-header">
                <div className="header">
                    <span className='header-title' title={item?.title}>{TextHelper.textLengthChecker(item?.title, 25)}</span>
                    {item?.type && (
                        <span className="d-flex gap-half align-items-center">
                            <Badge color={item?.type?.color}>{item?.type.label}</Badge>
                            <Tooltip
                                trigger='mouseenter'
                                content={
                                    <div className='d-flex flex-column'>
                                        {item?.conditions?.map((condition, index) => (
                                            <span key={index}>
                                                {condition?.key} {condition.operator.label} {condition.values?.[0]}
                                            </span>
                                        ))}
                                    </div>
                                }>
                                <span className='target'><ListIcon /></span>
                            </Tooltip>
                        </span>
                    )}
                </div>
            </div>
            <div className="ruleset-item-details">
                <div className="ruleset-info">
                    <Badge color={item?.urgency?.value} className='text-capitalize'>{item?.urgency.label}</Badge>
                </div>
                <div className="ruleset-info">
                    <Badge color={item?.enable ? 'success' : 'warning'}>
                        {item?.enable ? text.enabled : text.disabled}
                    </Badge>
                </div>
                <div className="ruleset-info">
                    <p>{updatedAt}</p>
                </div>
                <div className="ruleset-info actions">
                    <ActionButton
                        dispatch={dispatch}
                        onPopup={handleEditPopup}
                        isDarkMode={isDarkMode}
                    />
                </div>
            </div>
        </div>
    )
}

export default ListItem
